// @flow
import React from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import ProductGroupCardWithImpressions from 'app/common/react/components/profile/ProductGroupCard/ProductGroupCardWithImpressions';
import { track } from 'app/common/lib/react/analytics';

type Props = {|
  isOwnProfile: boolean,
  layout?: 'square' | 'wide',
  productGroup: Object,
  username: string,
|};

export default class ProductGroupCardContainer extends React.Component<Props> {
  handleProductGroupCardClick = () => {
    const { productGroup } = this.props;

    track(PCONST.thrift.EventType.CLICK, {
      objectId: productGroup.id,
      view: PCONST.thrift.ViewType.USER,
    });
  };

  render() {
    const { productGroup, layout, username } = this.props;

    if (!productGroup) {
      return null;
    }

    return (
      <NavigateLink
        onClick={this.handleProductGroupCardClick}
        to={`/${username}/_shop/${productGroup.id}/`}
      >
        <ProductGroupCardWithImpressions layout={layout} productGroup={productGroup} />
      </NavigateLink>
    );
  }
}
